<template>
  <validation-provider
    v-slot="{ errors }"
    :name="$attrs.name"
    :rules="iRules"
    :vid="vid"
  >
    <v-checkbox
      v-model="iValue"
      v-bind="$attrs"
      :dense="dense"
      :error-messages="errors"
      :hide-details="errors.length === 0 || !validation"
      :indeterminate="indeterminate"
      :label="displayLabel"
      v-on="$listeners"
    />
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { useValidation } from '@/compositions/validation'

export default {
  name: 'FieldCheckbox',
  components: {
    ValidationProvider
  },
  props: {
    dense: {
      type: Boolean,
      default: true
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    rules: {
      type: [String, Object],
      default: () => ({})
    },
    validation: {
      type: Boolean,
      default: false
    },
    vid: {
      type: String,
      default: null
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const { iRules, displayLabel } = useValidation(props)

    return { iRules, displayLabel }
  },
  computed: {
    iValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  created () {
    this.$off('input')
  }
}
</script>
